import logger from './logger';
import { browser } from "../base/lib-jitsi-meet";
/**
 * Begins a request to get available DesktopCapturerSources.
 *
 * @param {Object} options - Additional configuration for getting a list of
 * sources.
 * @param {Array} options.types - An array with DesktopCapturerSource type strings.
 * @param {Object} options.thumbnailSize - The desired height and width of the
 * return native image object used for the preview image of the source.
 * @returns {Function}
 */
export function obtainDesktopSources(options) {
    const { JitsiMeetElectron } = window;
    // TODO: delete this after 2 releases
    if (JitsiMeetElectron?.obtainDesktopStreams) {
        return new Promise((resolve, reject) => {
            JitsiMeetElectron.obtainDesktopStreams((sources) => resolve(_separateSourcesByType(sources)), (error) => {
                logger.error(`Error while obtaining desktop sources: ${error}`);
                reject(error);
            }, options);
        });
    }
    return APP.API.requestDesktopSources(options).then(({ sources, error }) => {
        if (sources) {
            return _separateSourcesByType(sources);
        }
        else if (error) {
            logger.error(`Error while obtaining desktop sources: ${error}`);
            return null;
        }
    });
}
/**
 * Оповестим electron что закрыли попап выбора экрана трансляции/шаринга
 * нужно для решения багов на linux
 */
export function stopObtainDesktopSources() {
    const { JitsiMeetElectron } = window;
    if (JitsiMeetElectron?.stopObtainDesktopStreams) {
        return JitsiMeetElectron?.stopObtainDesktopStreams();
    }
}
let cacheAudioSharingSupport;
export function isAudioScreenSharingSupported() {
    // @ts-ignore
    if (navigator.mediaDevices.getDisplayMedia) {
        const { JitsiMeetElectron } = window;
        if (JitsiMeetElectron) {
            if (cacheAudioSharingSupport !== undefined) {
                return cacheAudioSharingSupport;
            }
            cacheAudioSharingSupport = JitsiMeetElectron.isAudioScreenSharingSupported && JitsiMeetElectron.isAudioScreenSharingSupported();
            return cacheAudioSharingSupport;
        }
    }
    return false;
}
let cacheScreenSharingSupport;
export function isScreenSharingSupported() {
    const { JitsiMeetElectron } = window;
    // чтобы не ломать старых клиентов
    if (!JitsiMeetElectron || !JitsiMeetElectron.isScreenSharingSupported) {
        return true;
    }
    if (cacheScreenSharingSupport !== undefined) {
        return cacheScreenSharingSupport;
    }
    cacheScreenSharingSupport = JitsiMeetElectron.isScreenSharingSupported();
    return cacheScreenSharingSupport;
}
/**
 * Check usage of old jitsi meet electron version.
 *
 * @returns {boolean} True if we use old jitsi meet electron, otherwise false.
 */
export function oldJitsiMeetElectronUsage() {
    const { JitsiMeetElectron } = window;
    if (JitsiMeetElectron?.obtainDesktopStreams) {
        return true;
    }
    return false;
}
/**
 * Converts an array of DesktopCapturerSources to an object with types for keys
 * and values being an array with sources of the key's type.
 *
 * @param {Array} sources - DesktopCapturerSources.
 * @private
 * @returns {Object} An object with the sources split into separate arrays based
 * on source type.
 */
export function _separateSourcesByType(sources = []) {
    const sourcesByType = {
        screen: [],
        window: []
    };
    const filteredSourceNames = ["StatusIndicator"];
    sources = sources.filter(source => !filteredSourceNames.includes(source.name));
    sources.forEach(source => {
        const idParts = source.id.split(':');
        const type = idParts[0];
        if (sourcesByType[type]) {
            sourcesByType[type].push(source);
        }
    });
    return sourcesByType;
}
// module-scope кэш — живёт только пока не будет полной перезагрузки страницы
let cachedWindowQueryData = null;
export function getWindowQueryData() {
    // если уже разбирали в этой сессии (странице) — отдаём из кэша,
    // даже если GET-параметры из URL уже вычищены
    if (cachedWindowQueryData !== null) {
        return cachedWindowQueryData;
    }
    // иначе парсим из текущего URL и запоминаем на весь срок жизни страницы
    cachedWindowQueryData = parseWindowQueryData();
    return cachedWindowQueryData;
}
export function parseWindowQueryData() {
    const location = window.location;
    const fixQueryPrams = (str) => str.replace(/\D/g, '');
    try {
        const searchParams = new URL(location.href).searchParams;
        const isWebVersion = Boolean(Number(fixQueryPrams(searchParams.get('webVersion') ?? '0')));
        const isElectron = browser.isElectron() || isWebVersion;
        if (!searchParams || !isElectron) {
            return {
                isSingleConference: false,
                isSupportPreJoinPage: false,
                isWebVersion: false,
            };
        }
        const isSupportPreJoinPage = searchParams.get('isSupportPreJoinPage') ?? '0';
        const isSingleConference = searchParams.get('isSingleConference') ?? '0';
        return {
            isSingleConference: Boolean(Number(fixQueryPrams(isSingleConference))),
            isSupportPreJoinPage: Boolean(Number(fixQueryPrams(isSupportPreJoinPage))),
            isWebVersion: isWebVersion
        };
    }
    catch (error) {
        console.error('[ERROR GET QUERY PARAM] ', error);
        return {
            isSingleConference: false,
            isSupportPreJoinPage: false,
            isWebVersion: false,
        };
    }
}
